import React from 'react';

import AppLayout from '../lib/AppLayout';
import RiderLogo from '../lib/RiderLogo';
import AppLinks from '../lib/AppLinks';

export default function Welcome() {
  return <AppLayout>
    <div className='App-Card'>
      <RiderLogo />
      <h1 className='App-Card-title'>Welcome to Noa Rider</h1>
      <p className='App-Card-message'>{
        'Noa Rider is the perfect app for moving efficiently in and around ' +
        'your campus by bike. Get it now for your phone.'
      }</p>
      <AppLinks />
    </div>
  </AppLayout>
}



// WEBPACK FOOTER //
// ./src/views/Welcome.js